import { render, staticRenderFns } from "./FundsAccountCancel.vue?vue&type=template&id=cb8060f8&scoped=true&"
import script from "./FundsAccountCancel.vue?vue&type=script&lang=js&"
export * from "./FundsAccountCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8060f8",
  null
  
)

export default component.exports